import { render, staticRenderFns } from "./Inventory.vue?vue&type=template&id=53d086ae&"
import script from "./inventory.ts?vue&type=script&lang=ts&"
export * from "./inventory.ts?vue&type=script&lang=ts&"
import style0 from "./Inventory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports